import { render, staticRenderFns } from "./Atitle.vue?vue&type=template&id=9bab5dcc&scoped=true"
import script from "./Atitle.vue?vue&type=script&lang=js"
export * from "./Atitle.vue?vue&type=script&lang=js"
import style0 from "./Atitle.vue?vue&type=style&index=0&id=9bab5dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bab5dcc",
  null
  
)

export default component.exports